﻿import { Storage } from './storage';

export class ElementPosition {
  private $elementToPosition: JQuery;
  private containerWidth: number;
  private containerHeight: number;
  private elementWidth: number;
  private elementHeight: number;
  private position: Point = { top: 0, left: 0 };

  constructor($elementToPosition: JQuery) {
    if (!$elementToPosition || $elementToPosition.length == 0)
      throw new Error('$elementToPosition is required.');
    this.$elementToPosition = $elementToPosition;
  }
  setPositionByPoint(point: Point) {
    this.calculateHeightsAndWidths();
    this.position = point;
    this.setPosition();
  }
  setPositionCenterScreen() {
    this.calculateHeightsAndWidths($(<any>window));
    this.position.left = (this.containerWidth / 2) - (this.elementWidth / 2);
    var pageYOffset = Storage.get('scrollPositionBeforeReload') || window.pageYOffset;
    Storage.remove('scrollPositionBeforeReload');
    this.position.top = pageYOffset + (this.containerHeight / 2) - (this.elementHeight / 2);
    this.$elementToPosition.css(<any>this.position);
  }
  setPositionByElement($target: JQuery, xAlignment: string = 'left', yAlignment = 'bottom') {
    if (!$target || $target.length == 0)
      throw new Error('$target is required.');

    this.calculateHeightsAndWidths();
    var offset = $target.offset();

    this.position.top = offset.top + $target.outerHeight();
    this.position.left = offset.left;

    if (xAlignment == 'right') {
      this.position.left = this.position.left + $target.outerWidth() - this.$elementToPosition.outerWidth();
    }
    if (yAlignment == 'top') {
      this.position.top = this.position.top - $target.outerHeight() - this.$elementToPosition.outerHeight();
    }
    this.setPosition($target);
  }
  private setPosition($target?: JQuery, xAlignment: string = 'left') {
    var fitsInContainerHeight = this.elementHeight < this.containerHeight;
    var fitsInContainerWidth = this.elementWidth < this.containerWidth;
    var shouldFlipVertically = fitsInContainerHeight && this.containerHeight < this.position.top + this.elementHeight;
    var shouldFlipHorizontally = fitsInContainerWidth && this.containerWidth < this.position.left + this.elementWidth;

    if (shouldFlipVertically) {
      var newTopAfterFlip = this.position.top - this.elementHeight;
      if ($target) {
        newTopAfterFlip = newTopAfterFlip - $target.outerHeight();
      }

      if (newTopAfterFlip > 0)
        this.position.top = newTopAfterFlip;
    }
    if (shouldFlipHorizontally) {
      this.position.left = this.position.left - this.elementWidth;
      if ($target) {
        var widthOffset = xAlignment == 'left' ? $target.outerWidth() : -$target.outerWidth();
        this.position.left = this.position.left + widthOffset;
      }
    }

    this.$elementToPosition.css(<any>this.position);
  }
  private calculateHeightsAndWidths($container: JQuery = $(<any>document)) {
    this.containerWidth = $container.width();
    this.containerHeight = $container.height();
    this.elementWidth = this.$elementToPosition.width();
    this.elementHeight = this.$elementToPosition.height();
  }

  public static setPositionByElement($element: JQuery, $target: JQuery) {
    return new ElementPosition($element).setPositionByElement($target);
  }
}

// INTERFACE
export interface Point{
  top: number;
  left: number;
}

export default ElementPosition;